import { CalendarDateTime } from '@internationalized/date';
import { toISOString, toLocalCalendarDateTime } from '@shared/util/date';
import { DateRangeValue } from './types';

export function getDefaultDateRangeValue(): DateRangeValue {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return {
    start: new CalendarDateTime(year, month, day, 9, 0),
    end: new CalendarDateTime(year, month, day, 17, 0),
  };
}

export function handleRollover(
  prev: CalendarDateTime | null,
  next: CalendarDateTime | null,
): CalendarDateTime | null {
  if (!next) {
    return prev;
  }
  let updatedTime = next;
  if (prev?.minute === 59 && next.minute === 0) {
    updatedTime = next.set({ hour: prev.hour + 1 });
  }
  if (prev && next && prev.minute === 0 && next.minute === 59) {
    updatedTime = next.set({ hour: prev.hour - 1 });
  }
  if (prev?.hour === 11 && next.hour === 0) {
    updatedTime = next.set({ hour: 12 });
  }
  if (prev?.hour === 12 && next.hour === 23) {
    updatedTime = next.set({ hour: 11 });
  }
  if (prev?.hour === 0 && next.hour === 11) {
    updatedTime = next.set({ hour: 23 });
  }
  if (prev?.hour === 23 && next.hour === 12) {
    updatedTime = next.set({ hour: 0 });
  }
  return updatedTime;
}

export function getDateRange({
  startDate,
  endDate,
}: {
  startDate: CalendarDateTime | null;
  endDate: CalendarDateTime | null;
}): DateRangeValue | null {
  if (startDate && endDate) {
    return { start: startDate, end: endDate };
  }
  const date = startDate || endDate;
  if (date) {
    return { start: date, end: date };
  }
  return null;
}

export function getCalendarDateTime(dateStamp: string | undefined): CalendarDateTime | null {
  return dateStamp ? toLocalCalendarDateTime(dateStamp) : null;
}

export function getUpdatedDateTime(
  date: CalendarDateTime | null,
  time: CalendarDateTime | null,
): string | undefined {
  if (!date || !time) {
    return undefined;
  }
  const updatedDate = new CalendarDateTime(date.year, date.month, date.day, time.hour, time.minute);
  return toISOString(updatedDate);
}
